import React, { useState } from 'react'
import { useRefresh } from 'core/hooks/refresh'
import { useFilters } from 'core/hooks/filter'
import { API } from 'service'
import { Field } from 'core/components/form/field'
import { DateInput } from 'core/components/form/date-input'
import { maskMoney } from 'core/helpers/mask'
import { List } from 'core/components/list'
import startOfDay from 'date-fns/startOfDay'
import endOfDay from 'date-fns/endOfDay'
import subDays from 'date-fns/subDays'
import { toLocaleDate } from 'core/helpers/date'
import { Button } from 'core/components/button'
import { CouponPDF } from 'core/utils/pdf'

export const BuyStatementForm = ({ global: { modal }, route }) => {
  const columns = [
    { path: 'createdAt', title: 'Data', format: e => toLocaleDate(e.createdAt) },
    { path: 'value', title: 'Valor', format: e => maskMoney(e.value) },
    {
      title: 'Recibo',
      render: ({ id }) => (
        <Button
          type="button"
          customClassName="btn-secondary btn-sm btn-icon btn-icon-sm"
          icon="fas fa-download"
          onClick={() => {
            API.post('customerstatement.coupon', { id })
              .then(response => {
                const coupon = response.coupon.split(/\n/)
                const doc = new CouponPDF(coupon)
                doc.download(id)
              })
              .catch(error => modal.alert(error.message))
          }}
        />
      ),
    },
  ]

  const { values, setValues, filters } = useFilters(
    { startDate: subDays(new Date(), 30), startEnd: new Date() },
    ({ startDate, startEnd }) => [
      {
        items: [
          {
            name: 'createdAt',
            value: startOfDay(startDate),
            comparer: 'GreaterThanOrEqual',
          },
          {
            name: 'createdAt',
            value: endOfDay(startEnd),
            comparer: 'LessThanOrEqual',
          },
          {
            name: 'statementTypeId',
            value: 1,
            comparer: 'Equal',
          },
        ],
      },
    ],
  )

  const fetching = useState(false)
  const refresh = useRefresh()

  return (
    <div className="kt-portlet">
      <div className="kt-portlet__head">
        <div className="kt-portlet__head-label">
          <span className="kt-portlet__head-icon">
            <i className="kt-font-brand fas fa-receipt" />
          </span>
          <h3 className="kt-portlet__head-title">Recibos de Compra</h3>
        </div>
      </div>
      <div className="kt-portlet__body">
        <div className="row">
          <Field className="col-lg" label="Data Inicial">
            <DateInput
              customClassName="form-control-xl"
              onChange={startDate =>
                setValues(prev => ({
                  ...prev,
                  startDate,
                }))
              }
              value={values.startDate}
            />
          </Field>

          <Field className="col-lg" label="Data Final">
            <DateInput
              customClassName="form-control-xl"
              onChange={startEnd =>
                setValues(prev => ({
                  ...prev,
                  startEnd,
                }))
              }
              value={values.startEnd}
            />
          </Field>
        </div>
      </div>
      <div className="kt-portlet__body kt-portlet__body--fit">
        <List
          columns={columns}
          fetching={fetching}
          filters={filters}
          getItems={(query, signal) => API.getList('customerstatement', query, signal)}
          initialQuery={{ sort: [['createdAt', 'DESC']] }}
          modal={modal}
          primaryKey="id"
          refresh={refresh}
          route={route}
        />
      </div>
    </div>
  )
}
